import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';

import { PraticheComponent } from './pratiche/pratiche.component';
import { PraticheRoutingModule } from './pratiche-routing.module';
import { PraticaComponent } from './pratica/pratica.component';
import { DettagliComponent } from './pratica/dettagli/dettagli.component';
import { NoteComponent } from './pratica/note/note.component';
import { DocumentiComponent } from './pratica/documenti/documenti.component';
import { RateComponent } from './pratica/rate/rate.component';
import { QuestionarioComponent } from './pratica/questionario/questionario.component';
import { DomandaComponent } from './pratica/questionario/domanda.component';
import { BottomSheetUploadDocumentoComponent } from './pratica/documenti/bottomSheetUploadDocumento/bottomSheetUploadDocumento.component';

@NgModule({
  declarations: [
    PraticheComponent,
    PraticaComponent,
    DettagliComponent,
    DocumentiComponent,
    DomandaComponent,
    NoteComponent,
    QuestionarioComponent,
    RateComponent,
    BottomSheetUploadDocumentoComponent
  ],
  imports: [CommonModule, SharedModule, PraticheRoutingModule],
  entryComponents: [BottomSheetUploadDocumentoComponent]
})
export class PraticheModule {}
